
define('text!templates/modules/setting/business/blocks/custom-button/custom-button.html',[],function () { return '<div class="button-preview"></div>\n';});

